import { SubscriberInfo, AccountModel } from './../model/AccountModel';
import { ActiveSessionsReqObj } from './../model/ApiRequests/ApiReqObj';
import { Injectable } from '@angular/core';
import { UserModel } from './../model/UserModel';



import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ConfigurationService } from './common/configuration.service';
import { environment  } from "./../../environments/environment";
import { RenewPlanModel } from '../model/RenewPlan';
import { User } from '../model/User';
import { ForgotPassword } from '../model/ForgotPassword';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  private baseUrl: string;
  SessionsUrl : string;  
  accountDetailUrl: string;
  token : string; 
  RenewPlanObject: RenewPlanModel = {} as RenewPlanModel;

  constructor(private http : HttpClient, private config: ConfigurationService) { 

    this.baseUrl = config.baseHttpURL;
    this.SessionsUrl = this.baseUrl + '/api/v1/account/getactivesessions';  
    this.accountDetailUrl = this.baseUrl + '/api/v1/account/getaccountdetail';  
  
   
  }

  
  getAccountDetailFromLteHttp(i_account: number){
    let url = `${environment.lteHttpBaseUrl}/api/Accounts/${i_account}`;
      return this.http.get<any>(url);
  }

  getActiveSessionsFromLteHttp(model: ActiveSessionsReqObj, limit: number= 1000){
    let url = `${environment.lteHttpBaseUrl}/api/Accounts/activesessions?limit=${limit}`;
      return this.http.post<any>(url, model);
  }

  getCustomerBalance(i_customer: number){
    let url = `${environment.lteHttpBaseUrl}/api/customers/${i_customer}/balance`;
    return this.http.get<any>(url);
  }

  getCustomer(i_customer: number){
    let url = `${environment.lteHttpBaseUrl}/api/customers/${i_customer}`;
    return this.http.get<any>(url);
  }

  Unsubsciribe(model: any){
    const url = `${environment.lteHttpBaseUrl}/api/customers/unsusbscribeMail`;
    return this.http.post<any>(url, model);
  }

UpdateNin(model: any){
  model.Source="Selfcare";
    const url = `${environment.lteHttpBaseUrl}/api/Accounts/EditNin`;
    return this.http.post<any>(url, model);
  }

  getActiveSession(model : any)
  {  
 
    return this.http.post<any>(this.SessionsUrl, model);  
} 

getaccountdetail(model : any)
{  


  return this.http.post<any>(this.accountDetailUrl, model);  
} 


updateSuscriber( i_account: number, model: AccountModel){
 
  let url = `${environment.lteHttpBaseUrl}/api/accounts/${i_account}/subscriberinfo`;
  
  return this.http.post<any>(url, model);

}

 

SetPasswordr( userId: number, password: string, defaultpassword : boolean, i_account : string)
{
 
  let url = `${environment.lteHttpBaseUrl}/api/auth/user/${userId}/password`;

  var model: User = {} as User;
  model. UserID = userId;
  model. Password = password,
  model .DefaultPassword = defaultpassword,
  model. i_Account = i_account

  return this.http.post<any>(url, model);

}

FindUserName(model: ForgotPassword){

 
  //model.UserName = model.UserName.toLowerCase().replace("lte\\", "");

  //model.UserName  = encodeURI(model.UserName);

  let url = `${environment.lteHttpBaseUrl}/api/auth/user/find?username=${model.UserName}`;

  return this.http.get<any>(url);

}

ResetPassword(username: string){
//  username= username.toLowerCase().replace("lte\\", "");

  let url = `${environment.lteHttpBaseUrl}/api/auth/user/${username}/forgotpassword`;
  
  return this.http.post<any>(url, null);

}

UnblockAccount(i_customer: string){
 
    
    let url = `${environment.lteHttpBaseUrl}/api/accounts/${i_customer}/unsuspendCustomer`;
    return this.http.post<any>(url, null);
  
  }




}
